import {Component} from '@angular/core';
import {IonicPage, LoadingController, NavController, NavParams} from 'ionic-angular';

import {MainPage} from '../main/main';
import {NewRegistrationStep1Page} from '../new-registration-step1/new-registration-step1';
import {CertificatedPage} from '../certificated/certificated';
import {TermsPage} from '../terms/terms';

import {ValidatorProvider} from '../../providers/validator/validator';
import {AlertProvider} from '../../providers/alert/alert';
import {NetworkMonitorProvider} from '../../providers/network-monitor/network-monitor';
import {AuthProvider} from '../../providers/auth/auth';

import * as Config from '../../app/app.config';

/**
 * Generated class for the LoginPage page.
 *
 * See http://ionicframework.com/docs/components/#navigation for more info
 * on Ionic pages and navigation.
 */
@IonicPage({
  name: 'LoginPage',
  segment: 'login/:accessToken'
})
@Component({
  selector: 'page-login',
  templateUrl: 'login.html',
})
export class LoginPage {

  private accessToken: string;

  version: string = Config.version;
  // area: string;
  data: any = {
    email: '',
    password: ''
  };

  today: Date = new Date();

  constructor(
    public navCtrl: NavController,
    public navParams: NavParams,
    private loadingCtrl: LoadingController,
    private validatorProvider: ValidatorProvider,
    private alertProvider: AlertProvider,
    private authProvider: AuthProvider,
    private networkMonitorProvider: NetworkMonitorProvider
  ) {
    // this.area = '';
    // this.area += 'Total width/height: ' + screen.width + ' * ' + screen.height + '\n';
    // this.area += 'Available width/height: ' + screen.availWidth + ' * ' + screen.availHeight + '\n';
    // this.area += 'Color depth: ' + screen.colorDepth + '\n';
    // this.area += 'Color resolution: ' + screen.pixelDepth + '\n';
  }

  ionViewDidLoad() {
    // this.alertProvider.doAlert('Parada programada do sistema: de sexta-feira às 17h até segunda-feira às 8h.', 'Atenção');
    console.log('ionViewDidLoad LoginPage');

    this.accessToken = this.navParams.get('accessToken');
    console.log('accessToken', this.accessToken);
    if (this.accessToken) {
      this.doAccessTokenLogin();
    }

    addEventListener('load', () => {
      setTimeout(() => {
        window.scrollTo(0, 1);
      }, 100);
    }, false);
  }

  goContact() {
    this.alertProvider.doAlert('Caso mesmo assim sua dúvida permaneça, mande email para certificacaotransacional@institutototum.com.br. Contate-nos também através do telefone (11) 3372-9572 - opção 1.', 'Informação');
  }

  goToCertificatedPage() {
    this.navCtrl.push(CertificatedPage);
  }

  doLogin() {
    // DONE: Verifica se está vazio apenas (Motivo: bruna.-@hotmail.com)
    //if (!this.validatorProvider.isEmail(this.data.email)) {
    //  this.alertProvider.doAlert('Forneça um e-mail válido.', 'Atenção');
    if (this.validatorProvider.isEmpty(this.data.email)) {
      this.alertProvider.doAlert('Forneça um e-mail.', 'Atenção');
    } else if (this.validatorProvider.isEmpty(this.data.password)) {
      this.alertProvider.doAlert('Forneça uma senha.', 'Atenção');
    } else {
      if (!this.networkMonitorProvider.isOnline()) {
        this.alertProvider.doAlert('É necessário estar conectado na Internet para validar seu acesso.', 'Atenção');
      } else {
        let loader = this.loadingCtrl.create({
          content: 'Acessando...',
          //duration: 3000
        });
        loader.present();

        let that = this;
        this.authProvider.login(this.data).subscribe((allowed: any) => {
          if (allowed) {
            that.navCtrl.push(MainPage, {
              loader: loader
            });
          } else {
            loader.dismiss();
            that.alertProvider.doAlert('Acesso negado.', 'Atenção');
          }
        }, (error: any) => {
          console.log(error);
          loader.dismiss();
          that.alertProvider.doAlert('Acesso negado.', 'Atenção');
        });
      }
    }
  }

  doAccessTokenLogin() {
    let loader = this.loadingCtrl.create({
      content: 'Acessando...',
      //duration: 3000
    });
    loader.present();

    let that = this;
    this.authProvider.accessTokenLogin(this.accessToken).subscribe((allowed: any) => {
      if (allowed) {
        that.navCtrl.push(MainPage, {
          loader: loader
        });
      } else {
        loader.dismiss();
        that.alertProvider.doAlert('Acesso negado.', 'Atenção');
      }
    }, (error: any) => {
      console.log(error);
      loader.dismiss();
      that.alertProvider.doAlert('Acesso negado.', 'Atenção');
    });
  }

  doRecoverPassword() {
    // DONE: Verifica se está vazio apenas (Motivo: bruna.-@hotmail.com)
    //if (!this.validatorProvider.isEmail(this.data.email)) {
    //  this.alertProvider.doAlert('Forneça um e-mail válido.', 'Atenção');
    if (this.validatorProvider.isEmpty(this.data.email)) {
      this.alertProvider.doAlert('Forneça um e-mail.', 'Atenção');
    } else {
      let that = this;
      this.alertProvider.doConfirm('Você deseja recuperar a senha?', () => {
        let loader = that.loadingCtrl.create({
          content: 'Enviando pedido...',
          duration: 3000
        });
        loader.present();

        if (!that.networkMonitorProvider.isOnline()) {
          that.alertProvider.doAlert('É necessário estar conectado na Internet para recupear a senha.', 'Atenção');
        } else {
          that.authProvider.recoverPassword(that.data).subscribe((data: any) => {
            if ((data) && (data.reseted)) {
              that.alertProvider.doAlert('Acabamos de lhe enviar um e-mail com uma nova senha gerada.', 'Veja seu e-mail');
            } else {
              loader.dismiss();
              that.alertProvider.doAlert('Verique se o e-mail fornecido está correto.', 'Atenção');
            }
          }, (error: any) => {
            console.log(error);
            loader.dismiss();
            that.alertProvider.doAlert('Verique se o e-mail fornecido está correto.', 'Atenção');
          });
        }
      });
    }
  }

  goToNewRegistrationPage() {
    this.navCtrl.push(NewRegistrationStep1Page);
  }

  goToTermsPage() {
    this.navCtrl.push(TermsPage);
  }

}



// WEBPACK FOOTER //
// ./src/pages/login/login.ts